import clsx from 'clsx';
import { useMemo } from 'react';
import {
  EEngineRunStatus,
  IDepositExtended,
} from 'views/types/typeTransaction';

export function EngineRun({
  engineRun,
}: {
  engineRun: IDepositExtended['engineRun'];
}) {
  const pathFormatted = useMemo(() => {
    let result: string[] = [];
    if (!engineRun?.path || engineRun?.path?.length === 0) {
      result = ['No path available'];
      return result;
    }

    for (const step of engineRun?.path || []) {
      if (step) {
        const nodeType = step.split(':')[0];
        const nodeAddress = step.split(':')[1];
        if (nodeType === 'MEXC') {
          result.push(
            `${nodeType} (${nodeAddress})`?.replaceAll('_', ' ') || '---'
          );
        } else {
          result.push(`${nodeType}`?.replaceAll('_', ' ') || '---');
        }
      }
    }

    return result;
  }, [engineRun?.path]);

  return (
    <span className="font-semibold ml-3">
      <span className="text-gray-500">
        {pathFormatted?.map((step, i) => (
          <span key={i}>
            <span
              className={clsx(
                (i <= engineRun.currentStep ||
                  engineRun.status === EEngineRunStatus.SUCCESS) &&
                  'text-[#000]',
                i === engineRun.currentStep &&
                  [
                    EEngineRunStatus.PENDING,
                    EEngineRunStatus.IN_PROGRESS,
                    EEngineRunStatus.WAITING_FOR_BATCH,
                    EEngineRunStatus.BATCH_IN_PROGRESS,
                  ].includes(engineRun.status) &&
                  'animate-pulse'
              )}
            >
              {step}
              {i < pathFormatted.length - 1 && ' → '}
            </span>
          </span>
        ))}
      </span>
    </span>
  );
}
